import styled from '@emotion/styled';
import { Button } from '@mui/material';

const TabButton = styled(Button)`
  height: 45px;
  margin: 6px 0;
  border-radius: 28px;
  min-width: 145px;
  padding: 12px 20px;
  width: auto;
  text-transform: none;
  font-family: var(--font-work-sans);
  font-weight: 600;
  font-size: 16px;
  background: ${props => (props.className === 'active' ? '#FDF3DE' : '#4c3b51')};
  display: flex;
  align-items: center;
  box-shadow: none;
  line-height: 1.5;
  color: ${props => (props.className === 'active' ? '#231727' : '#FDF3DE')};
  :hover {
    cursor: pointer;
    background: #f1caba;
    box-shadow: none;
    color: #231727;
  }
`;

export default TabButton;
